import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import { teamFilterReducerFactories } from 'media-base-ui/redux/utils';

import actionTypes from './actionTypes';

/* State shape:
 {
     loadingState: {
        isLoading: bool
        success: bool
        errors: Array
     },
     coachsChallengesState: {
        coachesChallenges: Array
        total: int
     }
 }
 */

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_COACHS_CHALLENGES_DATA)(actionTypes.COACHES_CHALLENGES_DATA_RESPONSE);

const coachsChallengesReducer = (state = [], action) => {
    if (action.type === actionTypes.COACHES_CHALLENGES_DATA_RESPONSE) {
        return action.payload.coachsChallenges;
    }
    return state;
};

const totalReducer = (state = 0, action) => {
    if (action.type === actionTypes.COACHES_CHALLENGES_DATA_RESPONSE) {
        return action.payload.total;
    }
    return state;
}

const coachsChallengesStateReducer =  combineReducers({
    coachsChallenges: coachsChallengesReducer,
    total: totalReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    coachsChallengesState: coachsChallengesStateReducer
});

export default reducer;
